import { createContext } from "react";

import ConsigazApi from "./ConsigazApi";
import ConsigazReportApi from "./ConsigazReportApi";

export const defaultContext = {
  ConsigazApi,
  ConsigazReportApi,
};
export default createContext(defaultContext);
